<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import getSecret from '@utils/get-secret'
import DisableAutocomplete from 'vue-disable-autocomplete'
import Vue from 'vue'
import TermsAndConditions from '@components/terms'
Vue.use(DisableAutocomplete)

export default {
  page: {
    title: 'Register',
    meta: [
      { name: 'description', content: `Register to ${getSecret('TITLE')}` },
    ],
  },
  components: { Layout, TermsAndConditions },
  data() {
    return {
      fullname: '',
      email: '',
      password: '',
      terms: null,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      termsModalShow: false,
      hidePassword: true,
      hidePassword2: true,
    }
  },
  computed: {
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null
    },
    passwordType() {
      return this.hidePassword ? 'password' : 'text'
    },
    passwordIcon() {
      return this.hidePassword ? 'fa-eye' : 'fa-eye-slash'
    },
    passwordType2() {
      return this.hidePassword ? 'password' : 'text'
    },
    passwordIcon2() {
      return this.hidePassword ? 'fa-eye' : 'fa-eye-slash'
    },
  },
  methods: {
    ...authMethods,

    openTermsModal(plan) {
      this.planToChoose = plan
      this.termsModalShow = !this.termsModalShow
      return false
    },

    // Try to register the user in with the email, fullname
    // and password they provided.
    tryToRegisterIn() {
      this.tryingToRegister = true
      // Reset the regError if it existed.
      this.regError = null
      return this.register({
        fullname: this.fullname,
        email: this.email,
        password: this.password,
      })
        .then((token) => {
          this.tryingToRegister = false
          this.isRegisterError = false
          // Redirect to the originally requested page, or to the confirm-account page
          this.$router.push(
            this.$route.query.redirectFrom || { name: 'confirm-account' }
          )
        })
        .catch((error) => {
          this.tryingToRegister = false
          this.regError = error.response ? error.response.data.message : ''
          this.isRegisterError = true
        })
    },
  },
}
</script>

<template>
  <Layout>
    <b-modal
      id="signup-modal"
      v-model="termsModalShow"
      title="Terms and Conditions"
      size="lg"
      hide-footer
    >
      <TermsAndConditions />
    </b-modal>

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-10 col-lg-12 col-md-9">
          <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
              <div class="row">
                <div
                  class="
                    col-lg-6
                    d-none d-lg-block
                    bg-login-image
                    justify-content-center
                  "
                ></div>
                <div class="col-lg-6 p-5">
                  <div class="text-center m-auto">
                    <a href="/">
                      <span>
                        <img
                          v-if="getCompanyInfo && getCompanyInfo.light_logo"
                          :src="require('@assets/images/retina/logo.svg')"
                          alt="login"
                          height="120"
                          style="max-width: 100%"
                        />
                      </span>
                    </a>
                  </div>
                  <div class="p-3">
                    <b-alert
                      v-model="isRegisterError"
                      variant="danger"
                      dismissible
                    >
                      {{ regError }}
                    </b-alert>

                    <b-form @submit.prevent="tryToRegisterIn">
                      <b-form-group
                        id="fullname-group"
                        label="Full Name"
                        label-for="fullname"
                      >
                        <b-form-input
                          id="fullname"
                          v-model="fullname"
                          type="text"
                          required
                          placeholder="Enter your name"
                          autocomplete="off"
                        >
                        </b-form-input>
                      </b-form-group>

                      <b-form-group
                        id="email-group"
                        label="Email"
                        label-for="email"
                      >
                        <b-form-input
                          id="email"
                          v-model="email"
                          type="email"
                          required
                          placeholder="Enter email"
                          autocomplete="off"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group id="password-group" label-for="password">
                        <slot name="label">
                          <label class="d-block"
                            >Password
                            <i
                              class="fas"
                              :class="[passwordIcon]"
                              @click="hidePassword = !hidePassword"
                            ></i
                          ></label>
                        </slot>
                        <b-form-input
                          id="password"
                          v-model="password"
                          :type="passwordType"
                          required
                          placeholder="Enter password"
                          autocomplete="off"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group id="terms-group" label="" label-for="terms">
                        <b-form-checkbox
                          v-model="terms"
                          :indeterminate.sync="terms"
                          >I accept
                          <a @click="openTermsModal(plan)" class="text-dark"
                            >Terms and Conditions</a
                          ></b-form-checkbox
                        >
                      </b-form-group>

                      <b-form-group id="button-group" class="mt-4 mb-0">
                        <b-button
                          type="submit"
                          variant="success"
                          class="btn-block"
                          >Sign Up</b-button
                        >
                      </b-form-group>
                    </b-form>

                    <div class="row mt-3">
                      <div class="col-12 text-center">
                        <p class="text-dark-50">
                          Already have account?
                          <router-link
                            tag="a"
                            to="/login"
                            class="text-dark ml-1"
                            ><b>Log In</b></router-link
                          >
                        </p>
                        <p class="text-dark-50"
                          >Return to
                          <router-link tag="a" to="/" class="text-dark ml-1"
                            ><b>Home</b></router-link
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module></style>

<style scoped>
.bg-login-image {
  background: url('../../assets/images/fondos_auth/meadow.jpg');
  background-position: center;
  background-size: cover;
}
</style>
